module.exports = __webpack_public_path__ + "img/Jump Casting7.d2512daf.jpg";